import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './LoadContainers.frontend.types'

@Injectable({ providedIn: 'root' })
export class LoadContainers_create_loadcontainer_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { lookupcode?: string, orderTypeId: number, yardLocationId?: number, priority?: number, loadContainerContainerTypeId?: number, loadContainerId?: number }): Promise<{ reasons?: string[], loadcontainerId?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderTypeId)) {
      missingRequiredInParams.push('\'orderTypeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/functions/create_loadcontainer_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

